import request from '@/utils/request'

/**
 * 获取登录会员基本信息
 *
 * @export
 * @returns
 */
export function baseInfo() {
  return request({
    url: '/Api/Account/BaseInfo',
    method: 'post'
  })
}

/**
 * 上传头像图片
 * @param {*} data 文件
 * @export
 * @returns
 */
export function uploadAvatarImg(file) {
  const formData = new FormData()
  formData.append('image', file)
  return request({
    url: '/Api/Personal/Settings/UploadAvatarImg',
    method: 'POST',
    data: formData
  })
}

/**
 * 上传头像图片
 * @param {String} img 头像url
 * @export
 * @returns
 */
export function setAvatar(img) {
  return request({
    url: `/Api/Personal/Settings/SetAvatar?img=${img}`,
    method: 'POST'
  })
}

/**
 * 设置个人资料
 * @param {*} nickName 昵称
 * @param {*} name 姓名
 * @param {*} age 年龄
 * @param {*} job 职业
 * @param {*} headPicture 头像
 * @param {*} gender 性别
 * @param {*} address 详细地址
 * @param {*} provinceId 省
 * @param {*} cityId 市
 * @param {*} areaId 区
 * @export
 * @returns
 */
export function edit({ nickName, name, age, job, headPicture, gender, address, provinceId, cityId, areaId }) {
  return request({
    url: `/Api/Personal/Settings/Edit?nickName=${nickName}&name=${name}&age=${age}&job=${job}&headPicture=${headPicture}&gender=${gender}&address=${address}&provinceId=${provinceId}&cityId=${cityId}&areaId=${areaId}`,
    method: 'post'
  })
}

/**
 * 我关注的纪念馆
 *
 * @export
 * @returns
 */
export function myFollow() {
  return request({
    url: '/Api/Personal/Hall/MyFollow',
    method: 'post'
  })
}

/**
 * 关注/取消关注
 * @param {*} id 纪念馆id
 * @export
 * @returns
 */
export function isFollow(id) {
  return request({
    url: `/Api/Personal/Hall/Follow?hallId=${id}`,
    method: 'post'
  })
}

/**
 * 申请成为业务员
 * @param {*} name 用户名称
 * @export
 * @returns
 */
export function joinSalesman(name) {
  return request({
    url: `/Api/Personal/Salesman/Join?name=${name}`,
    method: 'post'
  })
}

/**
 * 退出登录
 */
export function logout() {
  return request({
    url: '/Api/Account/Logout',
    method: 'post'
  })
}
